import { Routes, Route, Navigate } from 'react-router-dom';
import { Suspense, lazy, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Nav } from '@/components/layout/Nav';
import { Footer } from '@/components/layout/Footer';
import { WhatsAppFab } from '@/components/layout/WhatsAppFab';
import { Skeleton } from '@/components/ui/Skeleton';
import Home from '@/pages/Home';

// Las rutas secundarias se cargan bajo demanda. /admin y /dashboard arrastran
// chart.js + react-chartjs-2, que así quedan fuera del bundle inicial de la home.
const Catalogo = lazy(() => import('@/pages/Catalogo'));
const Sedes = lazy(() => import('@/pages/Sedes'));
const Vacantes = lazy(() => import('@/pages/Vacantes'));
const Dashboard = lazy(() => import('@/pages/Dashboard'));
const Admin = lazy(() => import('@/pages/Admin'));
const Login = lazy(() => import('@/pages/Login'));

function RequireAuth({ children }: { children: React.ReactNode }) {
  const { initialized, isAuthed } = useAuth();
  if (!initialized) return null;
  if (!isAuthed) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function RequireAdmin({ children }: { children: React.ReactNode }) {
  const { initialized, isAdmin } = useAuth();
  if (!initialized) return null;
  if (!isAdmin) return <Navigate to="/" replace />;
  return <>{children}</>;
}

export default function App() {
  const { init } = useAuth();
  useEffect(() => {
    void init();
  }, [init]);

  return (
    <div className="min-h-screen flex flex-col">
      <Nav />
      <main className="flex-1 pt-[68px]">
        <Suspense fallback={<div className="wrap" style={{ padding: '64px 28px' }}><Skeleton className="h-64 w-full rounded-xl" /></div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catalogo" element={<Catalogo />} />
            <Route path="/sedes" element={<Sedes />} />
            <Route path="/vacantes" element={<Vacantes />} />
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <RequireAuth>
                  <Dashboard />
                </RequireAuth>
              }
            />
            <Route
              path="/admin"
              element={
                <RequireAdmin>
                  <Admin />
                </RequireAdmin>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
